module.exports = __webpack_public_path__ + "img/OV_Unterkunft.39b0f047.svg";